import React, { Component } from 'react';
import './styles.scss';
import { t } from '../../../../locales';

interface ListItemUnderlineProps {
  id: string;
  value: string;
}

export default class ListItemUnderline extends Component<ListItemUnderlineProps> {
  constructor(props: any = {}) {
    super(props);
  }

  render() {
    const { id, value } = this.props;
    return (
      <div className="list-item-underline content-align-right">
        <div className="list-item-underline_left">{t(id)}</div>
        <div className="list-item-underline_right">{value}</div>
      </div>
    );
  }
}
